import React, {useEffect,useState,} from 'react';
import {
    CAlert,
    CButton,
    CSpinner,
    CRow,
} from '@coreui/react'

import {getPaymentStatus} from '../../common/apiCalls/index'
import {PaymentStatus} from '../../common/enums/index'

const CountDownTimer = (props)=> {

    const [localState,setLocalState]=useState(
        {
          status:'',
          error:''
        }
      )
    const [timeRemaining, setTimeRemaining] = useState(props.paymentStatusCheck);

    useEffect(() => {

        const timerInterval = setInterval(() => {
          setTimeRemaining((prevTime) => {
            if (prevTime === 0) {
                clearInterval(timerInterval);
                async function fetcStatus() {
                    try {
                        const response = await getPaymentStatus(props.session_id);
                        if(response.status.code === 200){
                            let theStatus 
                            if(response.data.paymentStatus === PaymentStatus.RECEIPTED || 
                                response.data.paymentStatus === PaymentStatus.RECEIPT_DELIVERED
                            ){
                                theStatus =  response.data.receipt
                            }else{
                                theStatus = response.data.error
                            }
                            setLocalState({
                                ...localState,
                                status:theStatus,
                                error:''
                                });
                        }else{
                            setLocalState({
                                ...localState,
                                status:'',
                                error:response.status.message
                                })
                        }
                    } catch (error) {
                        setLocalState({
                                ...localState,
                                status:'',
                                error:error.message,
                            });
                    }

                }
                fetcStatus();
                return 0;
            } else {
              return prevTime - 1;
            }
          });
        }, 1000);
      // Cleanup the interval when the component unmounts
      return () => clearInterval(timerInterval);
    }, [localState,props]);

    const seconds = timeRemaining;

    return (
        <>
            <CRow className="justify-content-center">
                <CButton color="primary" disabled>
                    {
                        timeRemaining>0?
                            <CSpinner as="span" size="sm" aria-hidden="true" /> 
                        :
                            null
                    }
                    {` checking status in ${seconds} s   `}
                </CButton>
            </CRow> 
            <CRow className="justify-content-center">
                {
                    localState.status?
                    <CAlert color="primary">
                        <p>{localState.status}</p>
                    </CAlert>
                    :
                    null
                }
            </CRow>
        </>
    )

}

export default CountDownTimer